import { ApiV2Response } from '../../../../types/utils';
import { nzApiClient } from '../../../../utils';
import {
  AccountPlanRepository,
  CreatePlanError,
  NizzaPlan,
} from '../../domain';

export class RestAccountPlanRepository implements AccountPlanRepository {
  async get(planType: string, account?: string): Promise<NizzaPlan> {
    const response = await nzApiClient.rest<ApiV2Response<NizzaPlan>>({
      path: `/v1/plans/info`,
      queryParams: { planType },
      account,
    });

    return response.data;
  }

  async create(input: NizzaPlan): Promise<void> {
    const { success } = await nzApiClient.rest<ApiV2Response<void>>({
      path: `/v1/plans/create`,
      method: 'POST',
      body: input,
    });

    if (!success) {
      throw new CreatePlanError(input);
    }
  }
}
